import { Suspense, lazy } from "react";
import { Route, Switch } from "wouter";
import { Shell } from "./components/Shell.js";
import { Landing } from "./pages/Landing.js";

/*
 * The landing page is loaded eagerly and everything that touches the chain is not.
 *
 * viem is most of the bundle, and a reader who came to find out what SYRTY is should not download a
 * chain client to read a page of prose. The explorer pulls it in when someone actually asks to
 * verify something.
 */
const ReceiptExplorer = lazy(() =>
  import("./pages/ReceiptExplorer.js").then((m) => ({ default: m.ReceiptExplorer })),
);
const CureMonitor = lazy(() => import("./pages/CureMonitor.js").then((m) => ({ default: m.CureMonitor })));
const Deployment = lazy(() => import("./pages/Deployment.js").then((m) => ({ default: m.Deployment })));
const Evidence = lazy(() => import("./pages/Evidence.js").then((m) => ({ default: m.Evidence })));
const AgentLog = lazy(() => import("./pages/AgentLog.js").then((m) => ({ default: m.AgentLog })));
const Utilization = lazy(() => import("./pages/Utilization.js").then((m) => ({ default: m.Utilization })));
const RiskGraph = lazy(() => import("./pages/RiskGraph.js").then((m) => ({ default: m.RiskGraph })));
const Protocol = lazy(() => import("./pages/Protocol.js").then((m) => ({ default: m.Protocol })));
const Selection = lazy(() => import("./pages/Selection.js").then((m) => ({ default: m.Selection })));
const CreateMandate = lazy(() =>
  import("./pages/CreateMandate.js").then((m) => ({ default: m.CreateMandate })),
);
const Mandates = lazy(() => import("./pages/Mandates.js").then((m) => ({ default: m.Mandates })));
const MandateDetail = lazy(() =>
  import("./pages/MandateDetail.js").then((m) => ({ default: m.MandateDetail })),
);
const ProviderDetail = lazy(() =>
  import("./pages/ProviderDetail.js").then((m) => ({ default: m.ProviderDetail })),
);
const ProviderDirectory = lazy(() =>
  import("./pages/ProviderDirectory.js").then((m) => ({ default: m.ProviderDirectory })),
);

export function App() {
  return (
    <Shell>
      <Suspense fallback={<div className="page section caption">Loading…</div>}>
        <Switch>
          <Route path="/" component={Landing} />
          <Route path="/protocol" component={Protocol} />
          <Route path="/receipts" component={ReceiptExplorer} />
          <Route path="/receipts/:obligationId" component={ReceiptExplorer} />
          <Route path="/mandates" component={Mandates} />
          <Route path="/mandates/new" component={CreateMandate} />
          <Route path="/mandates/:mandateId" component={MandateDetail} />
          <Route path="/providers" component={ProviderDirectory} />
          <Route path="/providers/:providerId" component={ProviderDetail} />
          <Route path="/auctions" component={Selection} />
          <Route path="/cures/:obligationId" component={CureMonitor} />
          <Route path="/deployment" component={Deployment} />
          <Route path="/agents" component={AgentLog} />
          <Route path="/utilization" component={Utilization} />
          <Route path="/risk" component={RiskGraph} />
          <Route path="/evidence" component={Evidence} />
          <Route>
            <div className="page section stack">
              <h3>Not found</h3>
              <p>No such page.</p>
            </div>
          </Route>
        </Switch>
      </Suspense>
    </Shell>
  );
}
